import styles from "../../styles/profile/Promise.module.css";
import classNames from "classnames/bind";
import data from "../../data/promise.json";

const cx = classNames.bind(styles);

//고객과의 약속
export default function Promise() {
  const promises = data.promise;

  return (
    <section className={cx("promiseWrap")}>
      <div className={cx("title")}>
        <h4>고객과의 약속</h4>
        <p className={cx("subtitle")}>
          으뜸손해사정은 다음의 약속을 지키겠습니다.
        </p>
      </div>

      <div className={cx("cardGrid")}>
        {promises.map((item, index) => (
          <div key={index} className={cx("cardWrap", "reveal")}>
            <div className={cx("promiseCard", "card", "liftUp")}>
              <div className={cx("textBox")}>
                <div className={cx("textWrap")}>
                  <p className={cx("cardTitle")}>{item.title}</p>
                  <p className={cx("cardDesc")}>{item.desc}</p>
                </div>
              </div>
              <div className={cx("imgBox")}>
                <div className={cx("bg")}></div>
                <img src={item.src} alt={item.alt} />
              </div>
              <span className={cx("number")}>0{index + 1}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
